/* eslint-disable max-len */
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { copyTextToClipboard } from "./common/Clipboard";
import "../styles/styles.scss";
import { useTranslation } from 'react-i18next';

const BANK_ACCOUNT_RECIPIENT = "Extra English Alicja Martiniak";
const BANK_ACCOUNT_NUMBER = "36 1140 2004 0000 3502 8025 8272";

const PaymentPage = () => { const { t: tr } = useTranslation(); return (<div className="blurred-background legal-page payment-page">
    <Helmet>
      <title>{tr("public:extraEnglishPayments_94")}</title>
    </Helmet>
    <div className="legal-page__container">
      <header className="legal-page__header">
        <span className="legal-page__eyebrow">Extra English</span>
        <h1>{tr("public:paymentDetails_60")}</h1>
        <p>{tr("public:informationAboutBankTransfersOnlinePaymentsProcessedByAutopay_95")}</p>
      </header>

      <div className="payment-page__grid">
        <section className="legal-panel payment-page__bank-panel">
          <div className="legal-panel__title-row">
            <i className="fas fa-university"></i>
            <h2>{tr("public:bankTransferDetails_96")}</h2>
          </div>
          <div className="bank-account-row">
            <span>{tr("public:recipient_97")}</span>
            <div className="bank-account-box bank-account-box--text">
              <strong>{BANK_ACCOUNT_RECIPIENT}</strong>
              <button type="button" aria-label={tr("public:copyRecipient_98")} onClick={() => copyTextToClipboard(BANK_ACCOUNT_RECIPIENT)}>{tr("public:copy_51")}</button>
            </div>
          </div>
          <div className="bank-account-row">
            <span>{tr("public:bankAccount_50")}</span>
            <div className="bank-account-box">
              <strong>{BANK_ACCOUNT_NUMBER}</strong>
              <button type="button" aria-label={tr("public:copyAccountNumber_99")} onClick={() => copyTextToClipboard(BANK_ACCOUNT_NUMBER)}>{tr("public:copy_51")}</button>
            </div>
          </div>
          <p className="legal-page__note">{tr("public:includeTheChildsFirstAndLastNameGroupName_100")}</p>
          <a
            href="../../resources/offer/umowa_o_nauke_angielskiego_2026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="legal-action-link"
          >
            <i className="far fa-file-alt"></i>{tr("public:serviceAgreement_62")}</a>
        </section>

        <section className="legal-panel payment-page__online-panel">
          <div className="legal-panel__title-row">
            <i className="far fa-credit-card"></i>
            <h2>{tr("public:onlinePaymentMethods_101")}</h2>
          </div>
          <p>{tr("public:whereOnlinePaymentIsAvailableForAServicePayments_102")}</p>
          <img
            src="/resources/payment/autopay-blik-card-transfer-485x115.png"
            alt={tr("public:autopayBLIKCardPaymentsAndInstantBankTransfers_55")}
            className="autopay-payment-banner"
          />
          <div className="payment-methods payment-methods--light">
            <span>Visa</span>
            <span>Visa Electron</span>
            <span>Mastercard</span>
            <span>Mastercard Electronic</span>
            <span>Maestro</span>
          </div>
          <p className="legal-page__note">{tr("public:extraEnglishDoesNotStorePaymentCardDetails_56")}</p>
        </section>
      </div>

      <section className="legal-panel payment-page__wide-panel">
        <div className="legal-panel__title-row">
          <i className="far fa-clock"></i>
          <h2>{tr("public:fulfilmentAndRefunds_108")}</h2>
        </div>
        <p>{tr("public:orderFulfilmentTimeStartsWhenPaymentIsSuccessfullyAuthorised_109")} <Link to="/terms">{tr("public:extraEnglishTermsOfService_110")}</Link>.
        </p>
      </section>
    </div>
  </div>); };

export default PaymentPage;
